// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Peculiarities_wrapper__3fTPm","title":"Peculiarities_title__20jTO","list":"Peculiarities_list__1PV72"};